import {FC, ReactElement} from 'react'
import classNames from 'classnames'
import {Button} from 'design'
import {TriangleWarningIcon} from '../SvgIcon'
import {RenderIf} from '../RenderIf'

interface Props {
  children: ReactElement
  title: string
  data_cy?: string // for the thing that we want to delete
  data_cy_delete: string // for Delete button
  data_cy_cancel: string // for Cancel button
  data_cy_title?: string // for Header component button
  onDelete: () => void
  onCancel: () => void
  deleteText?: string
  deletePendingStatus?: boolean
  backgroundColor?: string
  deleteButtonText?: string
  deletePendingText?: string
  isSideSpaceRequired?: boolean
}

export const DeleteComponent: FC<Props> = ({
  children,
  title,
  deleteText = '',
  data_cy = 'delete-input',
  data_cy_delete,
  data_cy_cancel,
  backgroundColor = 'bg-dope-black',
  data_cy_title = 'delete_title',
  onDelete,
  onCancel,
  deletePendingStatus = false,
  deleteButtonText = 'Delete',
  deletePendingText = 'Deleting...',
  isSideSpaceRequired = true,
}) => {
  return (
    <div
      className={classNames(
        'overflow-y-auto',
        backgroundColor,
        isSideSpaceRequired ? 'px-6' : '',
      )}
    >
      <h1
        className="text-white abc-light text-2xl -mt-1"
        data-cy={data_cy_title}
      >
        {title}
      </h1>
      {children}
      <RenderIf isTrue={Boolean(deleteText)}>
        <span className="px-5 py-2.5 border-0.5 border-red-500 bg-red-400 bg-opacity-10 mt-4 flex justify-start items-center">
          <TriangleWarningIcon />
          <input
            placeholder="Policy Name"
            value={deleteText}
            disabled
            className="bg-transparent focus:outline-none placeholder-red-400 ml-2 text-xs karla w-64 truncate"
            data-cy={data_cy}
          />
        </span>
      </RenderIf>
      <section className="flex items-center justify-end mt-5">
        <Button
          variant="ghost"
          className="mr-4"
          fontWeight="bold"
          colorScheme="noBackground"
          onClick={onCancel}
          disabled={deletePendingStatus}
          data-cy={data_cy_cancel}
        >
          Cancel
        </Button>
        <Button
          onClick={onDelete}
          colorScheme="red"
          data-cy={data_cy_delete}
          disabled={deletePendingStatus}
        >
          {deletePendingStatus ? (
            <>
              <p className="mr-2" data-cy="loading">
                {deletePendingText}
              </p>
            </>
          ) : (
            deleteButtonText
          )}
        </Button>
      </section>
    </div>
  )
}
